
import  GUIDUtil from "../../../../util/GUIDUtil";
import StoryElement from "./StoryElement"
import StoryModelEvent from "./StoryModelEvent"
import StoryNode from "./StoryNode"
import StoryArc from "./StoryArc"
import ArrayIterator from "../../../../util/datastructures/array/ArrayIterator";
import EventDispatcher from "../../../../util/EventDispatcher";

export default class Story extends EventDispatcher {
    /**
     * @constructor
     * @param {*} data
     */
    constructor(data) {
        super()

        this.data = data;
        this.storyArcs = [];
    }
    /**
         * Insert a new StoryArc into the the Story
         * @param {*} data
         * @param {LogicalExpression} unlockCondition
         * @param {LogicalExpression} availableCondition
         * @param {boolean} storyEnd
         * @param {number} id
         * @returns StoryArc
         */
    insertStoryArc(data, unlockCondition, availableCondition, storyEnd, id) {
        id = typeof id !== 'undefined' ? id : this.generateID();

        var storyArc = new StoryArc(this, id, data, unlockCondition, availableCondition, storyEnd);
        this.storyArcs.push(storyArc);
        this.dispatchEvent(StoryModelEvent.STORY_ARC_ADDED, storyArc);
        return storyArc;
    }
    /**
         * Remove a story arc from the story
         * @param {StoryArc} storyArc
         * @returns {undefined}
         */
    removeStoryArc(storyArc) {
        this.storyArcs.remove(storyArc);
        this.dispatchEvent(StoryModelEvent.STORY_ARC_REMOVED, storyArc);
    }
    /**
         * Returns all the StoryArcs in the Array
         * @returns {Iterator}
         */
    getStoryArcs() {
        return new ArrayIterator(this.storyArcs);
    }
    /**
         * Set a certain StoryArc as the start StoryArc of the story.
         * @param {type} storyArc
         * @returns {undefined}
         */
    setStartStoryArc(storyArc) {
        this.start = storyArc;
    }
    /**
         * Returns the start story arc of the story
         * @returns {StoryArc}
         */
    getStartStoryArc() {
        return this.start;
    }
    /**
         * Get the StoryArc to which a StoryNode belongs
         * @param {StoryNode} storyNode
         * @returns {StoryArc}
         */
    getStoryArc(storyNode) {
        return storyNode.getStoryArc();
    }
    /**
         * Returns the StoryArc with the specified id in the Story or null if it does not exist
         * @param {number} id
         * @returns {StoryArc}
         */
    getStoryArcById(id) {
        for (var i = 0; i < this.storyArcs.length; i++) {
            if (this.storyArcs[i].id + "" === id + "") {
                return this.storyArcs[i];
            }
        }
        return null;
    }
    /**
         * Returns the StoryNode with the specified id in the Story or null if it does not exist
         * @param {number} id
         * @returns {StoryNode}
         */
    getStoryNodeById(id) {
        for (var i = 0; i < this.storyArcs.length; i++) {
            var storyNodeItr = this.storyArcs[i].getStoryNodes();

            while (storyNodeItr.hasNext()) {
                var storyNode = storyNodeItr.next();
                if (storyNode.id + "" === id + "") {
                    return storyNode;
                }
            }
        }
        return null;
    }
    /**
         * Generates a random id
         * @returns {number}
         */
    generateID() {
        return GUIDUtil.generateGUID();
    }
}










